import { api } from '@/lib/api'
import type { SuggestionListResponse } from './types'

export async function getSuggestions(page = 1, pageSize = 20) {
  const res = await api.get<SuggestionListResponse>('/api/suggestion', {
    params: { page, page_size: pageSize },
  })
  return res.data
}

export async function submitSuggestion(content: string) {
  const res = await api.post('/api/suggestion', { content })
  return res.data
}
